export default {
  undefined: "UNDEFINED",
  copyright: "2025 — Avtala Sverige AB",
  badge: "Badge",
  close: "Close",
  logout: "Logout",
  loading: "Loading...",
  Error: "An error occurred!",
  error: {
    default: "An error occurred",
    request: "Request failed",
    unauthorized: "Unauthorized",
    forbidden: "Permission denied",
  },
  dataIterator: {
    noResultsText: "No records found",
    loadingText: "Loading...",
  },
  dataTable: {
    itemsPerPageText: "Rows per page:",
    ariaLabel: {
      sortDescending: ": Sort descending.",
      sortAscending: ": Sort ascending.",
      sortNone: ": Unsorted.",
      activateDescending: "Activate for ascending sort order.",
      activateAscending: "Activate for descending sort order.",
    },
    sortBy: "Sort by",
  },
  dataFooter: {
    itemsPerPageText: "Objects per page:",
    itemsPerPageAll: "All",
    nextPage: "Next page",
    prevPage: "Previous page",
    firstPage: "First page",
    lastPage: "Last page",
    pageText: "{0}-{1} of {2}",
  },
  datePicker: {
    itemsSelected: "{0} selected",
    prevMonthAriaLabel: "Previous month",
    nextMonthAriaLabel: "Next month",
    prevYearAriaLabel: "Previous year",
    nextYearAriaLabel: "Next year",
  },
  noDataText: "No data",
  pagination: {
    ariaLabel: {
      previous: "Previous page",
      next: "Next page",
      page: "Page",
      currentPage: "Page",
      wrapper: "Pagination",
    },
  },
  carousel: {
    prev: "Previous page",
    next: "Next page",
    ariaLabel: {
      delimiter: "Page {0} of {1}",
    },
  },
  calendar: {
    moreEvents: "{0} more",
  },
  input: {
    clear: "Clear {0}",
    prependAction: "{0}",
    appendAction: "{0}",
    otp: "Enter code {0}",
  },
  fileInput: {
    counter: "{0} files",
    counterSize: "{0} files (of {1} total)",
  },
  timePicker: {
    am: "am",
    pm: "pm",
  },
  app: {
    home: "Home",
    admin: "Administration",
    menu: {
      modules: "Modules",
      history: "History",
    },
    reload: "Refresh",
    error: {
      generic: "A problem occurred!",
      avatar: {
        get: "Failed to load your profile image",
      },
      save: "Failed to save the information. Please try again later.",
    },
  },
  avtala: {
    app: {
      accounts: {
        label: "My Accounts",
      },
    },
    dashboard: {
      label: "Dashboard",
      invitations: "Invitations",
      invitation: {
        label: "Invitation from {0}",
        text: "You have an invitation from {0} for access to {1}",
        accept: "Accept",
        deny: "Deny",
      },
      todo: {
        title: "To do - {0}",
        empty: "Nothing urgent at the moment",
      },
      activity: {
        title: "Recent events",
        empty: "No events found",
      },
      contacts: {
        title: "My Contacts",
        empty: "Your favorite contacts are listed here",
      },
    },
    calendar: {
      label: "Calendar",
      title: "Calendar",
    },
    timeline: {
      label: "Timeline",
      title: "Timeline",
    },
    admin: {
      label: "Administration",
      title: "Administration",
    },
    contract: {
      name: "Name",
      number: "Number",
      number2: "Reference",
      product: "Product",
      address: "Address",
      view: "View",
      type: "Type",
      category: "Category",
      status: "Status",
      period: "Duration",
      startDate: "Start date",
      endDate: "End date",
      terminated: "Terminated date",
      cancelDate: "Cancel date",
      cancelOffset: "Termination clause",
      cancelOffsetHint: "Days / Months",
      autoExtended: "Extension",
      autoExtendedHint:
        "Number of months to extend contract, if not terminated",
      autoExtendedMax: "Max extension",
      autoExtendedMaxHint:
        "Maximun number of months the contract can be extended",
      currency: "Currency",
      value: "Value",
      valueHint: "per month",
      description: "Description",
      descriptionHint: "Short description of the contact purpose and terms",
      responsible: "Responsible",
      group: "Group",
      tags: "Tags",
      access: "Access",
      follow: "Follow contract to get notified of changes",
      details: "Details",
      parties: {
        title: "Parties",
        search: "Find and select party",
        noResult: "No contacts matched the query",
      },
      contacts: {
        title: "Contacts",
        add: {
          company: "New company",
          person: "New person",
          user: "Add user or group",
        },
        edit: {
          company: "Edit party",
          person: "Edit party",
          selected: "Edit selected party",
        },
        delete: {
          selected: "Remove selected party",
          confirm: {
            title: "Confirm remove party",
            text: "Are you sure you want to remove this party from the contract?",
          },
        },
      },
      users: {
        label: "User / team",
        add: {
          title: "Add user",
          user: {
            label: "User",
          },
          role: {
            label: "Role",
          },
          expires: {
            label: "Permission valid until",
          },
          orderIndex: {
            label: "Order",
          },
          notes: {
            label: "Comments",
          },
        },
        edit: {
          title: "Edit User",
        },
      },
      summary: {
        title: "Summary",
      },
      facts: {
        title: "Facts",
      },
      periods: {
        title: "Lifecycle",
        current: "Current period",
      },
      files: {
        label: "Documents",
        title: "Documents",
        nodata: "No files",
        toggleView: "Toggle between list and miniatures",
        upload: {
          help: "Upload documents",
          label: "Press here to upload files",
        },
      },
      reminders: {
        title: "Reminders",
      },
      notifications: {
        label: "Subscribe to notifications:",
        reminders: "Reminders",
        comments: "Comments",
        updates: "Updates,",
      },
      cancel: {
        none: "none",
        days: "days",
        date: "specific date",
        months: "months",
      },
      role: {
        label: "Roles",
        select: "Select roles for {0}",
        notes: "Notes",
      },
      findOrCreate: {
        title: "Add party",
      },
      overview: {
        label: "Overview",
        title: "Contract Overview",
        name: "Contract Name",
        contact: "Contract Party",
        startDate: "Start Date",
        endDate: "End Date",
        status: "Status",
        team: "Team",
        tags: "Tags",
        value: "Value",
        totals: "{0} contracts",
      },
      list: {
        label: "Find contracts",
        title: "Find Contracts",
        fromStartDate: "From start date",
        toStartDate: "To start date",
        fromEndDate: "From end date",
        toEndDate: "To end date",
        docs: {
          label: "Documents and files",
          help: "Search title, filename or word in document",
        },
        search: "Search",
        clear: "Clear",
        keepOpen: "Keep open",
        fromInvoiceDate: "From invoice date",
        toInvoiceDate: "To invoice date",
        noInvoice: "Exclude",
      },
      create: {
        label: "New contract",
        title: "Add Contract",
        documents: {
          title: "Document",
          subTitle:
            "If the agreement consists of multiple documents or is scanned as multiple files, first upload the file that contains the names and organization ids.",
        },
        contacts: {
          title: "Contracting parties",
          subTitle: "The parties to the agreement",
        },
        facts: {
          title: "Details",
          subTitle: "Contract name, number and categorization",
        },
        period: {
          title: "Lifecycle",
          subTitle: "Current contract period and terms",
        },
        team: {
          title: "Team",
          subTitle: "Internal users with access to this contract",
        },
        button: {
          save: "Save",
          cancel: "Cancel",
        },
      },
      show: {
        label: "View contract",
        title: "View Contract",
        facts: "Facts",
        period: {
          add: {
            label: "Add new period",
          },
        },
      },
      edit: {
        title: "Edit facts",
        label: "Edit details",
      },
      delete: {
        label: "Delete contract",
      },
      export: {
        title: "Export",
      },
      email: {
        label: "Send email",
      },
      share: {
        label: "Share link",
      },
      map: {
        label: "Show on map",
      },
      chart: {
        title: "Costs",
      },
      followup: {
        label: "Follow-up",
        title: "Follow-up",
      },
      comment: {
        title: "Comments",
        nodata: "Press here to be the first to comment this contract",
        help: "Add comment",
      },
      policies: {
        label: "Permissions",
        title: "Permissions",
        team: "Users in the contract's team",
        contract: {
          read: "Read contracts",
          create: "Add contracts",
          update: "Edit contracts",
          delete: "Delete contracts",
        },
        comment: {
          read: "Read comments",
          create: "Add comments",
          update: "Edit comments",
          delete: "Delete comments",
        },
        content: {
          read: "Read documents",
          create: "Upload documents",
          update: "Edit documents",
          delete: "Delete documents",
        },
      },
      requirements: {
        title: "Checklist",
      },
      invoice: {
        title: "Invoicing",
      },
      search: {
        label: "Find documents",
        title: "Documents",
        company: "Find company...",
        person: "Find person...",
        contact: "Find company or person...",
        hint: "Enter name or organization/person number to search",
        nodata: "No matching contact found. Press + to create a new contact",
      },
      timeline: {
        title: "{0}",
      },
      requirement: {
        title: "Requirements",
      },
      workflow: {
        add: {
          title: "New Action",
          help: "Create new action / reminder",
        },
        edit: {
          title: "Edit Action",
        },
        view: {
          title: "View settings",
        },
        category: {
          title: "Category settings",
        },
        contract: {
          title: "Contract settings",
        },
        settings: {
          label: "Settings",
        },
        name: {
          label: "Name",
          help: 'Name of action, for example "Reminder - indexation of prices"',
        },
        action: {
          label: "Type of action",
        },
        forced: {
          label: "Trigger action even if contract is not active",
        },
        relativeDateAction: {
          title: "Relative reminder",
          days: {
            label: "Number of days",
            help: "Relative to reference date",
          },
          relative: {
            label: "Relative",
            help: "Before or after reference date",
            options: {
              before: "Before",
              after: "Efter",
            },
          },
          field: {
            label: "Date field",
            help: "The reference date",
            options: {
              START_DATE: "Start Date",
              END_DATE: "End Date",
              CANCEL_DATE: "Cancel Date",
              CREATE_DATE: "Registration Date",
            },
          },
          time: {
            label: "Time of day",
            help: "Time of trigger",
          },
          adjust: {
            label: "Date adjust",
            help: "Adjustment of final date of trigger",
            options: {
              NONE: "No adjustment",
              FIRST_DAY_OF_MONTH: "First day of month",
              LAST_DAY_OF_MONTH: "Last day of month",
            },
          },
        },
        fixedDateAction: {
          title: "Fixed date reminder",
          date: { label: "Date" },
          time: { label: "Time" },
        },
        cronDateAction: {
          title: "Repeated reminder",
          month: {
            label: "Month",
            help: "Trigger month, or blank for all months",
          },
          dayOfMonth: {
            label: "Day",
            help: "Trigger day, or blank for all days",
          },
          dayOfWeek: {
            label: "Day of week",
            help: "Trigger day of week, or blank for any weekday",
          },
          time: {
            label: "Time of day",
          },
        },
        sendEmailAction: {
          title: "Send email notice",
          subject: {
            label: "Subject",
            help: "Message subject",
          },
          from: {
            label: "From",
            help: "Sender of the message. Leave empty for default address.",
          },
          to: {
            label: "To",
            help: "Recipient of the message. Leave empty for default recipients.",
          },
          template: {
            label: "Message Template",
            help: "Select template for the email message",
          },
          message: {
            label: "Message",
            help: "Custome message. Leave empty for default text",
          },
        },
        createInvoiceAction: {
          title: "Create invoice",
        },
      },
    },
    export: {
      templates: {
        title: "Print / Export",
        subtitle: "Select export layout",
        base: {
          docx: {
            title: "Microsoft Word",
          },
        },
      },
      started: "Export {0} started {1}",
    },

    followup: {
      method: {
        MANUAL: "Manual",
        SYSTEM: "Automatic",
      },
    },
  },

  crm: {
    default: {
      button: {
        new: "New",
        view: "View",
        save: "Save",
        delete: "Delete",
        remove: "Delete",
        add: "Add",
        close: "Close",
        cancel: "Cancel",
        ok: "Ok",
        search: "Find",
        more: "More...",
        confirm: "Confirm",
      },
    },
    general: {
      add: {
        label: "Add {0}",
      },
    },
    tags: {
      label: "Tags",
      title: "Tags",
    },
    contact: {
      name: "Name",
      companyName: "Company name",
      firstName: "First name",
      middleName: "Middle name",
      lastName: "Last name",
      email: "Email",
      phone: "Phone",
      telephone: "Phone",
      title: "Business title",
      sex: "Gender",
      number: "Number",
      number2: "Number 2",
      description: "Description",
      origin: "Origin",
      orgnr: "SSN",
      address: {
        label: "Address",
        address: "Address",
        address2: "Address 2",
        postalCode: "Zip code",
        city: "City",
        region: "State",
        country: "Country",
      },
      relation: "Relation",
      postal: "Postal address",
      visit: "Visit address",
      delivery: "Delivery address",
      invoice: "Invoice address",
      web: "Web",
      website: "Web",
      social: "Social media",
      internet: "Internet",
      twitter: "Twitter",
      facebook: "Facebook",
      instagram: "Instagram",
      linkedin: "LinkedIn",
      facts: {
        edit: "Edit facts",
      },
      tags: {
        label: "Tags",
      },
      relations: {
        title: "Relations",
        primary: "Primary relation",
        to: "Relation to",
        notes: "Notes",
        search: {
          employer: "Employer",
          hint: "Start typing to search",
          type: "Select type of relation",
        },
      },
      files: {
        label: "Files",
      },
      avatar: {
        upload: "Select image...",
      },
      type: {
        label: "Type",
        company: "Company",
        person: "Person",
      },
      button: {
        add: "Add contact",
      },
      show: {
        label: "View contact",
        contactInfo: "Contact information",
        facts: "Facts",
        summary: "Summary",
      },
      list: {
        label: "Address book",
        title: "Address Book",
        type: {
          all: "All contacts",
          company: "Only companies",
          person: "Only people",
        },
        search: "Search",
        clear: "Clear",
        stay: "Keep open",
      },
      add: {
        title: "Add new contact",
      },
      create: {
        label: "Add new contact",
        title: "Add new contact",
        company: {
          title: "Add new company",
        },
        person: {
          title: "Add new person",
        },
      },
      edit: {
        title: "Edit Contact Information",
      },
      search: {
        title: "Find Contact",
        addContact: "Add cnotact",
        searchHint: "Search by name",
        nameOrAddress: "Search name or address",
      },
      company: {
        number: "Number",
        number2: "Number 2",
        relations: {
          title: "Relations",
        },
      },
      person: {
        number: "SSN",
        number2: "Number 2",
        relations: {
          title: "Relations",
        },
      },
      summary: {
        title: "Summary",
      },
      export: {
        templates: {
          title: "Print / Export",
          subtitle: "Select format",
        },
      },
    },
    content: {
      list: {
        filesTitle: "Files",
        action: "",
      },
      edit: {
        title: "Edit File",
      },
      upload: {
        select: "Select files",
      },
      access: {
        label: "Access settings",
        anonymous: "Shared",
        authenticated: "Internal",
        private: "Private",
      },
      status: {
        label: "Status",
        undefined: "",
        DRAFT: "Draft",
        REVIEW: "Review",
        APPROVED: "Approved",
        PUBLISHED: "Published",
        ACTIVE: "Active",
        LOCKED: "Locked",
        ARCHIVED: "Archived",
        DELETED: "Deleted",
      },
      title: "Title",
      filename: "Filename",
      description: "Description",
      tags: "Tags",
      length: "Size",
      author: "Author",
      timeModified: "Modified",
      password1: "Password 1",
      password2: "Password 2",
    },
    comment: {
      send: "Save",
      messageHint: "New comment",
    },
    notification: {
      clearAll: "Clear all",
    },
    metadata: {
      contact: {
        relation: {
          type: "Type of relation",
        },
      },
      contract: {
        type: "Type",
        category: "Category",
        status: "Status",
      },
      crm: {
        currency: "Currency",
      },
    },
    role: {
      title: "Role",
      name: "Code",
      label: "Label",
      permissions: "Permissions",
      list: {
        title: "Roles",
      },
      owner: {
        label: "Account Admin",
      },
      admin: {
        label: "System Admin",
      },
      user: {
        label: "User",
      },
      viewer: {
        label: "Read-only",
      },
      guest: {
        label: "Guest",
      },
    },

    activity: {
      startTime: {
        label: "Start",
      },
      stopTime: {
        label: "End",
      },
      name: {
        label: "Id",
      },
      title: {
        label: "Label",
      },
      description: {
        label: "Description",
      },
      progress: {
        label: "Status",
        "-1": "Cancelled",
        0: "Planned",
        50: "In progress",
        100: "Completed",
      },
      repeat: {
        label: "Repeat",
        NONE: "Never",
        DAY: "Every day",
        WEEK: "Every week",
        MONTH: "Every month",
        YEAR: "Every year",
      },
      tags: {
        label: "Tags",
      },
      location: {
        label: "Location",
      },
      uri: {
        label: "Link",
      },
      username: {
        label: "Responsible",
      },
      reminder: {
        label: "Reminder",
      },
      show: {
        label: "Activity",
        title: "Activity",
      },
      create: {
        label: "Add activity",
        title: "Add Activity",
      },
      edit: {
        label: "Edit activity",
        title: "Edit Activity",
      },
    },
    form: {
      scope: {
        CONTRACT: "Contract",
        CONTACT: "Contact",
        COMPANY: "Company",
        PERSON: "Person",
      },
      dataType: {
        TEXT: "Text",
        INTEGER: "NUmber",
        DECIMAL: "Decimal",
        BOOLEAN: "Yes/No",
        DATE: "Date",
        DATETIME: "Time",
        SINGLE: "Single choice",
        MULTIPLE: "Multiple choice",
        TABLE: "Table",
      },
    },
    invoice: {
      queue: {
        title: "Invoicing",
        status: {
          DRAFT: "Draft",
          PENDING: "Pending",
          COMPLETED: "Completed",
          ERROR: "Error",
        },
        deliveryType: {
          label: "Distribution",
          NONE: "Manual",
          PRINT: "Print",
          EMAIL: "Email",
          PRINTSERVICE: "Print service",
          ELECTRONICINVOICE: "Electronic invoice",
        },
      },
      customer: {
        number: "Org.nr",
        number2: "Number",
        name: "Name",
      },
      address: "Address",
      email: "Email",
      telephone: "Phone",
      number: "Invoice number",
      invoiceDate: "Invoice date",
      dueDate: "Due date",
      ourReference: "Our reference",
      yourReference: "Your reference",
      termsOfPayment: "Payment terms",
      text: "Remarks",
      total: "Total",
      totalVat: "VAT",
      administrationFee: "Admin fee",
      totalToPay: "Total to pay",
      roundOff: "Rounding off",
    },
  },

  tenant: {
    editIcon: "Click to edit icon",
    editLogo: "Click to edit logo",
    name: "Organization",
    number: "Org.id",
    email: "Email",
    telephone: "Phone",
    description: "Description",
    website: "Web",
    update: "Update",
    address: {
      address: "Address",
      address2: "Address 2",
      postalCode: "Zip code",
      city: "City",
      region: "State",
      country: "Country",
    },
    invitation: {
      status: {
        created: "Created",
        accepted: "Accepted",
        denied: "Denied",
      },
    },
    updated: "Organization updated",
  },

  user: {
    firstName: "First name",
    lastName: "Last name",
    title: "Title",
    email: "Email",
    role: {
      label: "Role",
      administrator: "Admin",
      user: "User",
    },
    invite: {
      send: "Send invite",
    },
    settings: {
      darkTheme: "Dark mode",
      startView: {
        label: "Default view",
        dashboard: "Dashboard",
        overview: "Contracts",
        search: "Search",
        calendar: "Calendar",
      },
      homeAddress: "Home address",
    },
  },

  profile: {
    firstName: "First name",
    lastName: "Last name",
    title: "Title",
    company: "Company",
    number: "Number",
    email: "Email",
    telephone: "Phone",
    bio: "Biography",
    website: "Web",
    extra1: "Extra 1",
    extra2: "Extra 2",
    extra3: "Extra 3",
    edit: {
      title: "Contact Details",
      picture: "Click to edit profile photo",
      update: "Update",
      settings: "Settings",
    },
    updated: "Profile updated",
  },

  feature: {
    added: {
      message: "Feature added",
    },
    removed: {
      message: "Feature removed",
    },
    subscription: {
      label: "Subscription",
    },
    storage: {
      label: "Storage",
    },
    feature: {
      label: "Feature",
    },
    integration: {
      label: "Integration",
    },
    template: {
      label: "Templates",
    },
  },
};
